<template>
	<div class="section">
		<h1>联系我们</h1>
		<p>如果你有任何问题，请随时联系我们。</p>
	</div>
</template>

<script setup>
</script>

<style scoped>
.section {
	text-align: center;
	font-size: 2em;
	padding: 20px;
}
</style>